import {ChangeDetectionStrategy, Component, input} from '@angular/core';
import {StepperStep, StepperStepState} from 'ngx-heka-design-lib';

@Component({
  selector: 'app-stepper',
  templateUrl: './stepper.component.html',
  styleUrls: ['./stepper.component.scss'],
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class StepperComponent {
  readonly steps = input<StepperStep[]>([]);
  readonly stepStates = StepperStepState;
}